import { Box } from '@chakra-ui/react';
import React from 'react';
import config from '../constants/baseConfig';

const Background: React.FC = () => (
  <Box
    position="fixed"
    w="100vmax"
    h="100vmax"
    backgroundColor="bright.500"
    backgroundImage={`url("${config.urls.publicUrl}/bg.jpg?v=1")`}
    backgroundSize="cover"
    backgroundPosition="center"
    backgroundAttachment="fixed"
    zIndex={-1}
  />
);

export default Background;
